var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.103,
    height: 17.398,
    viewBox: "0 0 23.103 17.398",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.103,
    height: 17.398,
    fill: "#d84a4a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.607,9.513a2.094,2.094,0,0,0-.127.671,8.728,8.728,0,0,1-6.953,7.066,8.622,8.622,0,0,1-4.863-.49.96.96,0,0,0-.372-.067q-2.809,0-5.618,0a.636.636,0,0,1-.288-.034.318.318,0,0,1-.195-.348.306.306,0,0,1,.27-.288,1.484,1.484,0,0,1,.248-.008h4.5a12.029,12.029,0,0,1-.969-.746,8.591,8.591,0,0,1-2.944-7.535A8.269,8.269,0,0,1,11.549,4.1c.02-.032.038-.065.06-.1a.338.338,0,1,1,.57.36,8.678,8.678,0,0,0-.792,1.616,8.008,8.008,0,1,0,9.3-5.1A7.831,7.831,0,0,0,13.092,3.2c-.027.027-.052.055-.079.081a.347.347,0,0,1-.516.042.337.337,0,0,1,.022-.5c.207-.218.423-.429.643-.633a9.586,9.586,0,0,1,1.046-.807h-.28q-2.154,0-4.309,0c-.207,0-.378-.045-.425-.276a.329.329,0,0,1,.277-.4A1.319,1.319,0,0,1,9.7.7q2.8,0,5.6,0a.982.982,0,0,0,.373-.064A8.7,8.7,0,0,1,27.563,7.8c.005.047-.026.11.045.136Z",
    transform: "translate(-4.505 0)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.132,17.334A6.871,6.871,0,0,1,15.1,11.451,6.75,6.75,0,1,1,28.484,9.687c.017.127.028.255.039.382.023.249-.1.426-.306.445s-.344-.122-.365-.368a6.148,6.148,0,0,0-1.089-3.065,6.084,6.084,0,1,0,1.011,4.511c0-.022.006-.045.011-.067.054-.242.2-.359.407-.324s.294.188.26.427a5.879,5.879,0,0,1-.6,1.906,6.608,6.608,0,0,1-5.724,3.8",
    transform: "translate(-7.375 -1.871)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.624,12.554c0-.452,0-.9,0-1.355,0-.244.131-.4.331-.4s.345.154.346.411c0,.753.005,1.505,0,2.258,0,.158.042.2.2.2.3-.013.6-.007.9,0a.341.341,0,1,1,0,.675c-.466.007-.932.008-1.4,0-.261-.005-.377-.135-.379-.4,0-.459,0-.918,0-1.378",
    transform: "translate(-13.546 -5.293)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9,6.935c-.563,0-1.126,0-1.689,0-.279,0-.439-.127-.435-.341s.164-.336.424-.337q1.7,0,3.4,0c.263,0,.416.128.419.336s-.146.341-.431.341H4.9",
    transform: "translate(-1.36 -3.068)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.908,26.55c.57,0,1.141,0,1.711,0,.254,0,.394.119.4.327s-.147.35-.4.35q-1.712,0-3.423,0c-.256,0-.416-.139-.414-.346s.155-.331.42-.332c.57,0,1.141,0,1.711,0",
    transform: "translate(-1.361 -13.019)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.075,14.753c-.549,0-1.1,0-1.647,0-.272,0-.421-.117-.428-.325s.149-.353.427-.354q1.636,0,3.271,0c.277,0,.433.134.426.353s-.151.324-.426.325c-.541,0-1.083,0-1.624,0",
    transform: "translate(0 -6.901)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.075,18.732c.541,0,1.083,0,1.624,0,.274,0,.419.114.426.325s-.149.353-.426.354q-1.636,0-3.271,0c-.277,0-.434-.135-.427-.354s.156-.324.428-.325c.549,0,1.1,0,1.647,0",
    transform: "translate(0 -9.185)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82,11.468c-.225,0-.451,0-.676,0a.338.338,0,1,1-.01-.675q.687-.011,1.375,0a.338.338,0,1,1-.013.675c-.225.006-.451,0-.676,0",
    transform: "translate(-3.325 -5.289)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.816,22.015c.233,0,.466-.006.7,0a.336.336,0,1,1,.021.671c-.481.01-.962.011-1.443,0a.335.335,0,0,1,.024-.669c.232-.008.466,0,.7,0",
    transform: "translate(-3.325 -10.794)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.573,16.414a2.324,2.324,0,0,1,.292,0,.3.3,0,0,1,.29.315.3.3,0,0,1-.262.339,1.969,1.969,0,0,1-.649,0,.331.331,0,0,1,.014-.654,2.4,2.4,0,0,1,.314,0h0",
    transform: "translate(-8.814 -8.047)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.881,17.076a2.315,2.315,0,0,1-.292,0,.316.316,0,0,1-.3-.351.307.307,0,0,1,.316-.314,4.888,4.888,0,0,1,.54,0,.321.321,0,0,1,.327.33.326.326,0,0,1-.319.339,2.378,2.378,0,0,1-.27,0v0",
    transform: "translate(-17.794 -8.043)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.831,10.237a.336.336,0,0,1-.5.31,1.743,1.743,0,0,1-.5-.51.294.294,0,0,1,.05-.374.285.285,0,0,1,.366-.083,1.645,1.645,0,0,1,.564.567.242.242,0,0,1,.021.089",
    transform: "translate(-10.192 -4.681)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.424,9.551a.356.356,0,0,1,.3.178.3.3,0,0,1-.01.34,2.228,2.228,0,0,1-.477.475.3.3,0,0,1-.377-.021.286.286,0,0,1-.113-.359,1.553,1.553,0,0,1,.573-.586.332.332,0,0,1,.1-.029",
    transform: "translate(-16.537 -4.684)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.837,22.833a.375.375,0,0,1-.1.282c-.114.119-.229.239-.351.35a.337.337,0,1,1-.482-.472c.121-.133.251-.26.384-.381a.315.315,0,0,1,.359-.045.322.322,0,0,1,.195.267",
    transform: "translate(-10.198 -11.049)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.068,22.541a.308.308,0,0,1,.228.08c.134.131.273.259.4.4a.326.326,0,0,1-.022.466.315.315,0,0,1-.448.008,4.532,4.532,0,0,1-.411-.416.3.3,0,0,1-.033-.357.319.319,0,0,1,.291-.179",
    transform: "translate(-16.541 -11.053)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.625,7.31c0-.09-.007-.181,0-.271a.331.331,0,0,1,.348-.313.32.32,0,0,1,.322.315,4.169,4.169,0,0,1,0,.564.322.322,0,0,1-.324.314.335.335,0,0,1-.346-.316c-.009-.1,0-.2,0-.294",
    transform: "translate(-13.545 -3.298)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3,25.666c0,.09.006.181,0,.271a.336.336,0,0,1-.672,0,4.934,4.934,0,0,1,0-.542.338.338,0,0,1,.337-.327.343.343,0,0,1,.335.33c.007.09,0,.181,0,.271",
    transform: "translate(-13.542 -12.291)",
    fill: "#d84a4a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTime);
export default __webpack_public_path__ + "static/media/ic_time.7f15072ffbaadf7335537613b89b5340.svg";
export { ForwardRef as ReactComponent };